import {
    GetStaticProps, InferGetStaticPropsType
} from 'next';
import Head from 'next/head';

import {
    colors
} from '../../styles/_colors';
import SunnysideHeader from '../../components_sunnyside/header';
import ReviewsBanner from '../../sections/reviews/reviews_banner';
import ReviewsFavorites from '../../sections/reviews/reviews_favorites';
import BrightestSection from '../../sections/reusable/brightest';
import FooterFeatured from '../../sections/reusable/footer_featured';
import SunnysideFooter from '../../components_sunnyside/footer';
import prismic from '../../utils/prismic';
import {
    PrismicPaginatedResponse
} from '../../utils/prismic/types';
import {
    PrismicReviewsPageData
} from '../../utils/prismic/types/pages/reviews.type';
import SunnysideWrapper from '../../components_sunnyside/wrapper';
import SunnysideMain from '../../components_sunnyside/main';
import TrackingScripts from '../../sections/trackingScripts';

export const getStaticProps: GetStaticProps = async () => {
    const data: PrismicPaginatedResponse<PrismicReviewsPageData> = await prismic().get('reviews_page');
    return {
        props: {
            data,
            metaData: {
                ogTitle: 'Sunnyside Mindful Drinking Reviews',
                ogSiteName: 'Sunnyside',
                ogUrl: 'https://www.sunnyside.co/reviews',
                ogDescription: 'Sunnyside is loved and trusted by tens of thousands of members. Learn about the progress they&apos;ve been making and why they love Sunnyside.',
                ogImage: 'https://images.prismic.io/sunnysidetest/63e6349a-7e7b-4ce2-9841-54c570ebcda7_sunnyside-og.jpg?auto=compress,format',
                title: 'Sunnyside Mindful Drinking Reviews',
                disableNoIndex: true,
            }
        },
        revalidate: 30
    };
};

export default function ReviewsPage({
    data
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
    const reviewData = data.results[0];
    const reviews = data.results[0].data.reviews;
    return (
        <SunnysideWrapper>
            <TrackingScripts />
            <Head>
                <meta
                    name="description"
                    content="Sunnyside is loved and trusted by tens of thousands of members. Learn about the progress they've been making and why they love Sunnyside."
                />
                <link
                    rel="canonical"
                    href="https://www.sunnyside.co/reviews"
                />
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />
                <meta
                    name="twitter:site"
                    content="@joinsunnyside"
                />
                <meta
                    name="twitter:creator"
                    content="@joinsunnyside"
                />
            </Head>
            <SunnysideHeader bgcolor={colors.cloud}/>
            <SunnysideMain>
                <ReviewsBanner reviewData={reviewData}/>
                <ReviewsFavorites reviews={reviews}/>
                <BrightestSection />
                <FooterFeatured />
            </SunnysideMain>
            <SunnysideFooter />
        </SunnysideWrapper>
    );
}
